module.exports = __webpack_public_path__ + "img/paths-f4bcf45.png";